"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLupaColor = exports.getLupaStatus = exports.LUPA_STATUS = void 0;
exports.getSessionStatusAndColor = getSessionStatusAndColor;
const dayjs_1 = __importDefault(require("dayjs"));
const theme_1 = require("../theme");
var LUPA_STATUS;
(function (LUPA_STATUS) {
    LUPA_STATUS["MET"] = "met";
    LUPA_STATUS["NOT_MET"] = "notMet";
    LUPA_STATUS["PARTIALLY_MET"] = "partiallyMet";
    LUPA_STATUS["NOT_AVAILABLE"] = "notAvailable";
})(LUPA_STATUS || (exports.LUPA_STATUS = LUPA_STATUS = {}));
const getLupaStatus = (lupa, actualVisitCount) => {
    const lupaStatus = {};
    lupa &&
        Object.keys(lupa).forEach(key => {
            lupaStatus[key] =
                actualVisitCount[key] >= lupa[key]
                    ? LUPA_STATUS.MET
                    : actualVisitCount[key] > 0
                        ? LUPA_STATUS.PARTIALLY_MET
                        : LUPA_STATUS.NOT_MET;
        });
    return lupaStatus;
};
exports.getLupaStatus = getLupaStatus;
const getLupaColor = (currentDay, lupaPeriodStart, lupaPeriodEnd, lupaStatus) => {
    if (lupaPeriodStart && lupaPeriodEnd && lupaStatus) {
        const isCurrentDayInLupaPeriod = currentDay.isSame(lupaPeriodStart) ||
            currentDay.isSame(lupaPeriodEnd) ||
            (currentDay.isAfter(lupaPeriodStart) &&
                currentDay.isBefore(lupaPeriodEnd));
        if (!isCurrentDayInLupaPeriod)
            return null;
        const firstSessionEnd = (0, dayjs_1.default)(lupaPeriodStart)
            .startOf("day")
            .add(29, "day")
            .endOf("day");
        const isCurrentDayInFirstSession = currentDay.isBefore(firstSessionEnd);
        return isCurrentDayInFirstSession
            ? theme_1.HHNTheme.lupa[lupaStatus.firstSession]
            : theme_1.HHNTheme.lupa[lupaStatus.secondSession];
    }
};
exports.getLupaColor = getLupaColor;
// Color mapping for session statuses
const sessionStatusColors = {
    met: theme_1.HHNTheme.lupa[LUPA_STATUS.MET],
    partialMet: theme_1.HHNTheme.lupa[LUPA_STATUS.PARTIALLY_MET],
    notMet: theme_1.HHNTheme.lupa[LUPA_STATUS.NOT_MET],
    notAvailable: theme_1.HHNTheme.lupa[LUPA_STATUS.NOT_AVAILABLE],
};
// Helper to determine status color for a session
function getSessionStatusAndColor(lupaCount, actualVisitCount) {
    if (lupaCount === 0 || lupaCount == null || actualVisitCount == null)
        return {
            status: LUPA_STATUS.NOT_AVAILABLE,
            color: sessionStatusColors.notAvailable,
        };
    if (actualVisitCount >= lupaCount)
        return {
            status: LUPA_STATUS.MET,
            color: sessionStatusColors.met,
        };
    if (actualVisitCount > 0 && actualVisitCount < lupaCount)
        return {
            status: LUPA_STATUS.PARTIALLY_MET,
            color: sessionStatusColors.partialMet,
        };
    return {
        status: LUPA_STATUS.NOT_MET,
        color: sessionStatusColors.notMet,
    };
}
